import {
  postReq,
  END_POINTS
} from '@/api'

const state = {
  changePassword: {
    userName: '',
    oldPassword: '',
    newPassword: '',
    newPasswordComfirm: ''
  },
  isShowChangePasswordModal: false
}

const actions = {
  async updatePwdByOldPwd({
    state
  }) {
    const data = {
      userName: state.changePassword.userName,
      oldPassword: state.changePassword.oldPassword,
      newPassword: state.changePassword.newPassword
    }
    return postReq(END_POINTS.UPDATE_PWD_BY_OLDPWD, { data })
  }
}

const mutations = {
  updateIsShowChangePasswordModal(state, value) {
    state.isShowChangePasswordModal = value
  },
  updateChangePasswordUserName(state, value) {
    state.changePassword.userName = value
  },
  updateChangePasswordOldPassword(state, value) {
    state.changePassword.oldPassword = value
  },
  updateChangePasswordNewPassword(state, value) {
    state.changePassword.newPassword = value
  },
  updateChangePasswordNewPasswordComfirm(state, value) {
    state.changePassword.newPasswordComfirm = value
  },
  emptyChangePassword(state) {
    state.changePassword.userName = ''
    state.changePassword.oldPassword = ''
    state.changePassword.newPassword = ''
    state.changePassword.newPasswordComfirm = ''
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/forgetPwd/index.js